import React, { Component } from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";

import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import EqualizerOutlinedIcon from "@mui/icons-material/EqualizerOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import SavingsOutlinedIcon from "@mui/icons-material/SavingsOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import SourceOutlinedIcon from "@mui/icons-material/SourceOutlined";
//import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";

import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
//import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";

import DashboardHeader from "./DashboardHeader";
import SummaryCard from "../../components/dashlibs/SummaryCard";
import SectionCard from "../../components/dashlibs/SectionCard";
import StatusBadge from "../../components/dashlibs/StatusBadge";
import AlertList from "../../components/dashlibs/AlertList";
import { MockBarChart, MockTrendChart } from "../../components/dashlibs/MockChart";
import type { DashboardPageProps } from "./dashboard.types";

import type { ChartTone } from "../../components/charts";
import { DonutChart, AreaTrendChart, BarChart, TreemapChart, BulletChart, SankeyChart } from "../../components/charts";

// const costCenterExecution = [
//   { label: "Direction Générale", value: 52, color: "#163A5F" },
//   { label: "Opérations", value: 67, color: "#116B43" },
//   { label: "DSI", value: 38, color: "#D68910" },
//   { label: "Bingo", value: 59, color: "#2471A3" },
//   { label: "Bobo", value: 47, color: "#7D3C98" },
// ];

// const productExecution = [
//   { label: "Super", value: 49, color: "#116B43" },
//   { label: "Gasoil", value: 46, color: "#163A5F" },
//   { label: "Gaz", value: 58, color: "#2471A3" },
//   { label: "Jet A1", value: 33, color: "#D68910" },
// ];

// const monthlyExecution = [34, 46, 50, 39, 61, 72, 69, 74, 66, 79, 83, 88];

// const riskItems = [
//   {
//     title: "Surconsommation potentielle sur achats hydrocarbures",
//     description: "Le rythme d'exécution est supérieur à la trajectoire budgétaire attendue au S1.",
//     tone: "warning" as const,
//   },
//   {
//     title: "Sous-exécution sur investissements courants",
//     description: "Retard d’engagement sur plusieurs lignes d’équipement et de sécurisation des sites.",
//     tone: "danger" as const,
//   },
//   {
//     title: "Exécution stable sur charges de fonctionnement",
//     description: "Le profil de consommation reste compatible avec l’enveloppe annuelle projetée.",
//     tone: "success" as const,
//   },
// ];

// const linePressure = [
//   { label: "LI-SUP-BIN-25", value: 71, color: "#116B43" },
//   { label: "LI-GAS-BOB-25", value: 64, color: "#163A5F" },
//   { label: "LI-CHF-SIE-25", value: 44, color: "#2471A3" },
//   { label: "LI-INV-BIN-SEC", value: 33, color: "#D68910" },
// ];



// ActivityDashboard.tsx          
// ExecutiveDashboard.tsx         
// BudgetDashboard.tsx            
// OperationsDashboard.tsx        
// VarianceDashboard.tsx
// PerformanceDashboard.tsx                  
// ProjectsDashboard.tsx
// RequisitionDashboard.tsx 
// DataQualityDashboard.tsx       
// StaffingDashboard.tsx  


// UnifiedDrillHost.tsx
// BudgetDashboardDrill.tsx       
// PerformanceDashboardDrill.tsx  
// VarianceDashboardDrill.tsx






export default class BudgetDashboard extends Component<DashboardPageProps,any> {
  //const { period,cycle} = sharedFilters;
render(){
  const {userData,dashData,sharedFilters,filterOptions,onFilterChange,onRefresh} = this.props;
  const {meta,sections={},summaryCards=[]} = dashData || {};

  const {scenarioBreakdown={},costCenterBreakdown={},accountGroupBreakdown={}} = sections;
  const {topChanges={},budgetFlow={}} = sections;

  // const scenarioBreakdown = sections.scenarioBreakdown || {};
  // const costCenterBreakdown = sections.costCenterBreakdown || {};
  // const accountGroupBreakdown = sections.accountGroupBreakdown || {};
  // const topChanges = sections.topChanges || {};


  const iconMap: any = {
    wallet: <AccountBalanceWalletOutlinedIcon />,
    baseline: <FactCheckOutlinedIcon />,
    edit: <EditNoteOutlinedIcon />,
    investment: <BusinessCenterOutlinedIcon />,
    expense: <ReceiptLongOutlinedIcon />,
    equalizer: <EqualizerOutlinedIcon />,
    warning: <WarningAmberOutlinedIcon />,
  };


// * DonutChartCard for CAPEX/OPEX/HR/Other
// * StackedAreaChart for budget vs actual over time
// * BulletChart for selected budget vs adopted/revised
// * SankeyFlowChart later for ABB flow: budget → activity → output/product


  return (
    <Box sx={{ p: { xs: 2, md: 3 }, display: "grid", gap: 2.5 }}>
      <DashboardHeader
        title="Dashboard Budget"
        subtitle="Vue détaillée de la performance budgétaire, de l’absorption, des écarts et des zones de pression."
        userData={userData}
        sharedFilters={sharedFilters}
        filterOptions={filterOptions}
        onFilterChange={onFilterChange}
        onRefresh={onRefresh}
      />

      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 2 }}>
        {(summaryCards || []).map((card: any) => (
        <SummaryCard
          key={card.code}
          title={card.label}
          value={card.valueFormatted}
          subtitle={card.subtitle}
          delta={card.deltaFormatted}
          tone={card.tone}
          icon={iconMap[card.icon] || <AccountBalanceWalletOutlinedIcon />}
        />
        ))}
      </Box>

      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mt: 2 }}>
        <SectionCard
          title={scenarioBreakdown.title || "Répartition par scénario"}
          subtitle={scenarioBreakdown.subtitle || "Comparaison des versions budgétaires."}
        >
          <DonutChart data={(scenarioBreakdown.data || [])}
          />
        </SectionCard>

        <SectionCard
          title={accountGroupBreakdown.title || "Répartition par groupe de comptes"}
          subtitle={accountGroupBreakdown.subtitle || "Structure CAPEX, OPEX, RH et autres."}
        >
          <DonutChart data={accountGroupBreakdown.data || []}/>
        </SectionCard>
      </Box>

      <Box sx={{ display: "grid", gridTemplateColumns: "1.35fr 1fr", gap: 2, mt: 2 }}>
        <SectionCard
          title={costCenterBreakdown.title || "Répartition par centre de coûts"}
          subtitle={costCenterBreakdown.subtitle || "Budget par centre de responsabilité."}
        >
          <BulletChart data={(costCenterBreakdown.data || [])}
          />
        </SectionCard>

        <SectionCard
          title={topChanges.title || "Principales révisions"}
          subtitle={topChanges.subtitle || "Écarts les plus significatifs entre adopté et révisé."}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1, maxHeight: 360, overflowY: "auto",  }}>
            {(topChanges.data || []).map((x: any) => (
              <Box
                key={x.accountcode}
                sx={{
                  p: 1.5,
                  border: "1px solid #E2E8EE",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box>
                  <Typography sx={{ fontWeight: 700, color: "#163A5F" }}>
                    {x.accountname || x.accountcode}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {x.accountcode}
                  </Typography>
                </Box>

                <Box sx={{ textAlign: "right" }}>
                  <Typography sx={{ fontWeight: 700 }}>
                    {Number(x.delta || 0).toLocaleString()} FCFA
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Adopté: {Number(x.adopted || 0).toLocaleString()} · Révisé:{" "}
                    {Number(x.revised || 0).toLocaleString()}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </SectionCard>
      </Box>

      {/* <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "1fr" }}>
        <SectionCard
          title={budgetFlow.title || ""}
          subtitle={budgetFlow.subtitle || ""}
        >
          <SankeyChart data={budgetFlow.data || []} />
        </SectionCard>
      </Box> */}




      {/* <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            lg: "repeat(6, 1fr)",
          },
        }}
      >
        
        <SummaryCard
          title="Budget approuvé"
          value="69,94 Md"
          subtitle="Enveloppe révisée"
          delta="+25,72%"
          tone="info"
          icon={<AccountBalanceWalletOutlinedIcon />}
        />
        <SummaryCard
          title="Exécuté"
          value="30,84 Md"
          subtitle="Réalisation cumulée"
          delta="44,1%"
          tone="success"
          icon={<PaidOutlinedIcon />}
        />
        <SummaryCard
          title="Disponible"
          value="39,10 Md"
          subtitle="Solde restant"
          delta="55,9%"
          tone="default"
          icon={<SavingsOutlinedIcon />}
        />
        <SummaryCard
          title="Rythme"
          value="+3,2 pts"
          subtitle="vs mois précédent"
          delta="Accélération"
          tone="success"
          icon={<TimelineOutlinedIcon />}
        />
        <SummaryCard
          title="Lignes à risque"
          value="5"
          subtitle="Sous surveillance"
          delta="2 urgentes"
          tone="warning"
          icon={<WarningAmberOutlinedIcon />}
        />
        <SummaryCard
          title="Engagements"
          value="12,6 Md"
          subtitle="Non encore liquidés"
          delta="18,0%"
          tone="default"
          icon={<SourceOutlinedIcon />}
        />
      </Box> */}

      {/* <Grid container spacing={2}>
        <Grid size={{xs:12,lg:8}}>
          <SectionCard
            title="Tendance Budget vs Exécution"
            subtitle="Lecture mensuelle de l’absorption budgétaire sur l’exercice sélectionné."
            action={<StatusBadge label="Trajectoire surveillée" tone="info" />}
          >
            <MockTrendChart points={monthlyExecution} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Alertes budgétaires"
            subtitle="Exceptions et points d’attention nécessitant un arbitrage."
          >
            <AlertList items={riskItems} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Exécution par centre de coûts"
            subtitle="Niveau d’absorption par entité budgétaire."
          >
            <MockBarChart data={costCenterExecution} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Pression par ligne budgétaire"
            subtitle="Lignes consommant le plus rapidement leur enveloppe."
            action={<StatusBadge label="Top lignes" tone="warning" />}
          >
            <MockBarChart data={linePressure} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Exécution par produit"
            subtitle="Répartition synthétique par famille produit."
          >
            <MockBarChart data={productExecution} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <SectionCard
            title="Lecture analytique"
            subtitle="Messages de gestion à retenir pour la période."
          >
            <Stack spacing={1.25}>
              {[
                ["L’absorption globale reste soutenue", "Le niveau d’exécution est compatible avec le profil attendu mais les achats hydrocarbures doivent être suivis de près."],
                ["Les investissements sont en retrait", "La sous-exécution sur certaines lignes d’investissement peut affecter les projets de sécurisation et de modernisation."],
                ["Le fonctionnement est stable", "Les charges de fonctionnement restent sous contrôle comparativement aux autres masses budgétaires."],
              ].map(([title, desc]) => (
                <Box
                  key={title}
                  sx={{
                    p: 1.5,
                    borderRadius: "10px",
                    border: "1px solid #E2E8EE",
                    bgcolor: "#FFFFFF",
                  }}
                >
                  <Typography sx={{ fontSize: 13, fontWeight: 800, color: "#17324D" }}>
                    {title}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "#66788A", mt: 0.5, lineHeight: 1.65 }}>
                    {desc}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <SectionCard
            title="Vue gouvernance budgétaire"
            subtitle="Synthèse simple pour les arbitrages de management."
          >
            <Stack spacing={1.5}>
              {[
                ["Taux d’exécution", "44,1%", "success"],
                ["Masse la plus exposée", "Achats hydrocarbures", "warning"],
                ["Masse la plus en retard", "Investissements courants", "danger"],
                ["Centre le plus dynamique", "Direction Centrale des Opérations", "info"],
              ].map(([label, value, tone]) => (
                <Stack
                  key={label}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{
                    p: 1.25,
                    borderRadius: "10px",
                    bgcolor: "#F8FAFB",
                    border: "1px solid #E2E8EE",
                  }}
                >
                  <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#33495C" }}>
                    {label}
                  </Typography>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography sx={{ fontSize: 13, color: "#17324D", fontWeight: 800 }}>
                      {value}
                    </Typography>
                    <StatusBadge label={String(tone).toUpperCase()} tone={tone as any} />
                  </Stack>
                </Stack>
              ))}
            </Stack>
          </SectionCard>
        </Grid>
      </Grid> */}
    </Box>
  );
}
}
